import { toast } from 'react-toastify';

export default {
    success: (msg, id) => {
        return toast.success(msg, {
            toastId: id ? `toast-${id}` : 'toast-success',
            className: 'toastSuccessStyle',
            progressClassName: 'toastSuccessProgressBar'
        })
    },


    error: (msg, id) => {
        return toast.error(msg, {
            toastId: id ? `toast-${id}` : 'toast-error',
            className: 'toastErrorStyle',
            progressClassName: 'toastErrorProgressBar'
        })
    },

    info: (msg, id) => {
        return toast.info(msg, {
            toastId: id ? `toast-${id}` : 'toast-info'
        })
    }
}

export const handleRedirectMessage = (location, showToast = true) => {
    if (!location || !location.search) return;

    // check if it is a redirected visit from another page
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.get('redirected')) {
        if (showToast) {
            const fromPath = queryParams.get('from');
            const reason = queryParams.get('reason') || '';
            const pageName = queryParams.get('pageName');
            const toastStyle = {
                toastId: 'toast-error',
                className: 'toastErrorStyle',
                progressClassName: 'toastErrorProgressBar'
            }

            // Improved messaging based on reason
            let message = '';

            if (reason.includes('not_logged_in')) {
                message = `Please log in to access ${pageName}. Your session may have expired.`;
            } else if (reason.includes('access_denied')) {
                message = `You don't have permission to access ${pageName}. Please contact our sales team to upgrade your account.`;
            } else {
                // Generic fallback message
                message = `Access to ${pageName} is restricted. Please contact your account manager if you believe this is an error.`;
            }

            // Show appropriate toast
            toast.error(message, toastStyle);
        }
        // Clean up URL parameters
        setTimeout(() => {
            // Get the current pathname and search params safely
            const currentPath = window.location.pathname;
            const searchParams = new URLSearchParams(window.location.search);

            // Remove redirect-related parameters
            searchParams.delete('redirected');
            searchParams.delete('from');
            searchParams.delete('reason');
            searchParams.delete('pageName');

            // Construct clean URL
            const cleanUrl = searchParams.toString()
                ? `${currentPath}?${searchParams.toString()}`
                : currentPath;

            window.history.replaceState({}, '', cleanUrl);
        }, 100);
    }
}

